module.exports = __webpack_public_path__ + "static/media/online-class-min.48ea5d4f.png";